(function(){
const rt=window.L4UFinderRuntime;
if(rt&&Array.isArray(rt.CATALOG)){
const additions=[
{"id":"FAM-144","category":"Bag","useCases":["Gym / Sport","Travel / Weekend"],"vendor":"Goodyear","style":"Mile Sport Bag Small","productType":"Reistassen","sizeRole":"Medium Sport / Travel","volume":43.0,"height":null,"width":null,"depth":null,"laptopMax":null,"material":"","features":[],"handle":"goodyear-mile-small-sporttas-zwart","mappedProductId":"gid://shopify/Product/9609239363931","bestEligible":true,"inventory":44},
{"id":"FAM-145","category":"Bag","useCases":["Gym / Sport","Travel / Weekend"],"vendor":"Goodyear","style":"rPET Sport Bag 27L","productType":"Reistassen","sizeRole":"Compact Sport / Travel","volume":27.0,"height":null,"width":null,"depth":null,"laptopMax":null,"material":"RPET","features":[],"handle":"goodyear-plunjezak-reistas-sporttas-rpet-blauw","mappedProductId":"gid://shopify/Product/8575711773019","bestEligible":true,"inventory":140},
{"id":"FAM-146","category":"Bag","useCases":["Travel / Weekend","Gym / Sport"],"vendor":"Discovery","style":"Drive Wheeled 75 cm","productType":"Reistassen met wielen","sizeRole":"Large Wheeled Travel","volume":125.0,"height":null,"width":null,"depth":null,"laptopMax":null,"material":"","features":["wheels"],"handle":"discovery-drive-wieltas-75cm-zwart","mappedProductId":"gid://shopify/Product/9682857591131","bestEligible":true,"inventory":40}
];
for(const p of additions){if(!rt.CATALOG.some(x=>x.id===p.id))rt.CATALOG.push(p);}
}
const current=document.currentScript;
if(!current?.src)return;
try{
const u=new URL(current.src,document.baseURI);
u.pathname=u.pathname.replace(/l4u-smart-finder-polish\.js$/,'l4u-smart-finder-polish-base.js');
u.search='';
const script=document.createElement('script');
script.src=u.toString();
script.async=false;
document.head.appendChild(script);
}catch(e){}
})();
